import { useWorkspaceMassActions } from '@components/v2/layout/AppTemplate/hooks/useWorkspaceMassActions';
import { MassActionsFilterConfig } from '@components/v2/layout/MassActionsBar/massActionsBar.types';
import { useMassActionsContext } from '../contexts/MassActions.context';
import { UseListMassActionsParams } from './useListMassActions.types';

export function useListMassActions<T, Item>({
  list,
  actions,
  onClickAction,
  totalResults,
  isAllSelected,
  toggleAllSelected,
  testId,
}: UseListMassActionsParams<T, Item>) {
  const {
    massActionFilter,
    toggleMassActionFilter,
    toggleListItems,
    clearSelection,
    filterMaxResults,
  } = useMassActionsContext();

  const resolvedTotalResults = totalResults ?? filterMaxResults;

  const selectedCount = list.state.selecteds?.length ?? 0;
  const totalSelected = massActionFilter ? (resolvedTotalResults ?? 0) : selectedCount;
  const resolvedIsAllSelected =
    isAllSelected ?? (list.checkbox.isAllItemsSelected || massActionFilter);
  const resolvedToggleAllSelected =
    toggleAllSelected ?? (massActionFilter ? toggleListItems : list.checkbox.toggleSelectAll);

  const massActionFilterConfig: MassActionsFilterConfig = resolvedTotalResults
    ? {
        enabled: true,
        value: massActionFilter,
        totalResults: resolvedTotalResults,
        onToggle: toggleMassActionFilter,
      }
    : { enabled: false };

  const configObj = {
    totalSelected,
    actions,
    onClickAction,
    isAllSelected: resolvedIsAllSelected,
    toggleAllSelected: resolvedToggleAllSelected,
    deselectAll: clearSelection,
    massActionFilter: massActionFilterConfig,
    testId,
  };

  const config = totalSelected > 0 ? configObj : null;

  useWorkspaceMassActions<T>(config);
}
